export default __webpack_public_path__ + "static/media/vc1.eb13509c.svg";